import React, { createContext, useContext, useState } from "react";

const initialState = {
  allowEdit: false,
  salvarDoc: false,
  confirmarCadastro: false,
  cadastroEnabled: true,
  edicaoEnabled: true,
  cadastroCampos: {
    rg: false,
    filiacao: false,
    orgaoExpedidor: false,
    uf: false,
    nacionalidade: false,
  },
  edicaoCampos: {
    endereco: false,
    certidao: false,
  },
  iaModuleType: 'api', 
  iaApiNumber: '', 
  iaApiInstructions: '', 
  telefones: [], 
  habilitado: true, 
};

const AiRegiContext = createContext();

export const AiRegiProvider = ({ children }) => {
  const [listData, setListData] = useState([]); 
  const [settingsAI, setSettingsAI] = useState(initialState); 

  const setIaModuleType = (type, options = {}) => {
    setSettingsAI(prev => ({
      ...prev,
      iaModuleType: type,
      iaApiNumber: options.iaApiNumber || '',
      iaApiInstructions: options.iaApiInstructions || '',
    }));
  };

  const updateListData = (newData) => setListData([...newData]);
  const updateSettingsAI = (newSettings) => {
    const cadastroPadrao = { rg: false, filiacao: false, orgaoExpedidor: false, uf: false, nacionalidade: false };
    const edicaoPadrao = { endereco: false, certidao: false };
    setSettingsAI(prev => ({
      ...prev,
      cadastroCampos: { ...cadastroPadrao, ...(prev.cadastroCampos || {}), ...(newSettings.cadastroCampos || {}) },
      edicaoCampos: { ...edicaoPadrao, ...(prev.edicaoCampos || {}), ...(newSettings.edicaoCampos || {}) },
      telefones: newSettings.telefones !== undefined ? newSettings.telefones : (prev.telefones || []),
      habilitado: typeof newSettings.habilitado === 'boolean' ? newSettings.habilitado : (prev.habilitado !== undefined ? prev.habilitado : true),
      ...newSettings,
    }));
  };

  const setAllowEdit = (value) => {
    setSettingsAI(prev => ({
      ...prev,
      allowEdit: value,
    }));
  };

  const saveAllToBackend = async () => {
  };

  return (
    <AiRegiContext.Provider
      value={{
        listData,
        setListData, 
        updateListData, 
        settingsAI,
        updateSettingsAI, 
        setIaModuleType, 
        setAllowEdit,
        allowEdit: settingsAI.allowEdit, 
        saveAllToBackend,
      }}
    >
      {children}
    </AiRegiContext.Provider>
  );
};

export const useAiRegi = () => useContext(AiRegiContext);
